import { Box, Button, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FinanceProgram } from '@trnsact/trnsact-shared-types';

interface Props {
  selectedFinanceProgram: FinanceProgram;
}

export const InsuranceRequirements = ({ selectedFinanceProgram }: Props) => {
  return (
    <Box /* display="flex" flexDirection="column" */>
      <Typography component="p" variant="h6">
        Insurance Requirements
      </Typography>
      {!selectedFinanceProgram.insuranceCoverage?.coverageRequirements && (
        <>
          <Typography component="p" variant="body2" sx={{ color: '#00000099' }}>
            The selected finance program is missing{' '}
            <Box component="span" sx={{ fontWeight: 600 }}>
              Coverage Requirements
            </Box>
            . You can add them manually or request them from the selected lender
          </Typography>
          <Button onClick={() => {}} size="small" sx={{ marginTop: 1, marginBottom: 1 }}>
            Request from Lender
          </Button>
        </>
      )}
      <Box display="flex" alignItems="end">
        <InfoOutlinedIcon color="primary" sx={{ marginRight: 0.5 }} />
        <Typography component="p" variant="subtitle2" color="primary">
          These requirements and instructions will be applied to the selected submission
        </Typography>
      </Box>
    </Box>
  );
};
